const roleActions = {
    GET_ROLE_LIST: 'GET_ROLE_LIST',
    SET_ROLE_LIST: 'SET_ROLE_LIST',
};

export default roleActions;